// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"4b2b744a","421":"2f2e8397","643":"00be5e4c","670":"2972f479"}[chunkId] + ".chunk.css";
};